import React, { useState } from "react";
import './Dropdown.css';

const Dropdown = ({ data, value, callback, label, labelFontSize = "14px" }) => {
    const [openMenu, setOpenMenu] = useState(false);

    const handleValue = (item) => {
        callback(item);
        setOpenMenu(false);
    };

    const handleClick = (e) => {
        e.preventDefault();
        setOpenMenu(!openMenu);
    };

    return (
        <div className="dropdown px-4 pb-2 flex flex-col">
            <label
                className="pl-1"
                style={{
                    fontSize: labelFontSize || "14px",
                    color: "#393938",
                    fontWeight: "600"
                }}
            >
                {label || "Select Option"}
            </label>

            <button onClick={handleClick} className="dropdown-toggle">
                {value || (
                    <span style={{ fontSize: "16px", color: "#adadadff", fontWeight: "400" }}>
                        e.g., 2 days, 3 weeks 
                    </span>
                )}
                <svg
                    width="12"
                    height="8"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M1 1.5L6 6.5L11 1.5"
                        stroke="#393938"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
            {openMenu && (
                <ul className="dropdown-menu">
                    {data.map((item) => (
                        <li key={item} onClick={() => handleValue(item)}>
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
